let _this;
let queryTimer = null;
let scrollTimer = null;
let filterTimer = null;
let perPage = 50;
let listDom;
let searchParams = {
  page:1,
  perPage:perPage,
  sortName:"time",
  sortType:1,
  enabledPaging:true,
};

function hideNotification(e){
  if($(e.target).parents('.dy-notification').length <= 0
    && $(e.target).parents('.utm-real-time-box').length <= 0
    && Array.from(e.target.classList).indexOf('all-real-time-msg-close') === -1
   ){
    _this.show = false;
  }
}
import scrollLoadList from './scrollLoadList.vue'
export default {
  name:'dynamicNotification',
  components:{scrollLoadList},
  data() {
    _this = this;
    return {
      show:false,
      accessZoneList: [], // 点位列表
      areaList: [], // zone列表
      filterUsertypes:[], // 过滤的用户类型
      filterCategory:null,
      filterIds: [], // 过滤点位或zone
      totalPageCount:1, //总页数
      newRecordTime:0, //最新记录的时间
      timeline:null,
      notificationList:[],
    }
  },
  mounted() {
    _this = this;
    _this.getNewNotification();
    $(document).bind('click', hideNotification);
  },
  beforeDestroy(){
    this.show = false;
    $(document).unbind('click', hideNotification);
    clearInterval(queryTimer);
    clearTimeout(scrollTimer);
    clearTimeout(filterTimer);
    clearTimeout(_this.timeline);
  },
  methods: {
    // 打开
    open:function(){
      if(!this.show){
        this.show = true;
        this.getFilterData();
        this.filterUsertypes = [];
        this.filterCategory = null;
        this.filterIds = [];
        searchParams = {
          page:1,
          perPage:perPage,
          sortName:"time",
          sortType:1,
          enabledPaging:true,
        };
        this.$root.isNotification = false;
        this.notificationList = [];
        if(this.$root.adminInfo.permissionCodes && this.$root.adminInfo.permissionCodes.indexOf('M_ViewDynamicNotification') > -1 ){
          this.getNotificationList(1);
          this.readAllNotification();
        }
      }
    },
    // 重置筛选参数
    resetParams:function(){
      this.filterUsertypes = [];
      this.filterCategory = null;
      this.filterIds = [];
      this.filterResult();
    },
    // 筛选参数改变
    handleFilterChange:function(){
      clearTimeout(filterTimer);
      filterTimer = setTimeout(()=>{
        this.filterResult();
      },500);
    },
    // 筛选
    filterResult:function(){
      searchParams.page = 1;
      searchParams.recordTypes = this.filterCategory || this.filterCategory === 0 ? [this.filterCategory]:[];
      searchParams.userTypes = this.filterUsertypes.slice();
      searchParams.accessZoneIds = this.filterIds.filter(value => {
        return /^point/.test(value)
      }).map(value => {
        return value.slice(5)
      });
      searchParams.areaIds = this.filterIds.filter(value => {
        return /^area/.test(value)
      }).map(value => {
        return value.slice(4)
      });
      _this.getNotificationList();
    },
    /*获取通知数据*/
    /**
     *  flag 判断是否是刷新
     * */
    getNotificationList:function(flag){
      let data = JSON.parse(JSON.stringify(searchParams));
      if(this.$root.curNodeInfo.id){
        data.queryNodeId = this.$root.curNodeInfo.id;
      }
      if(_this.$root.curOfficeInfo.id) {
        data.officeIds = [_this.$root.curOfficeInfo.id]
      }
      /*定时刷新只刷新第一页以当前数据的第一条时间为搜索事件定时查询第一页，并将数据去重放入第一页*/
      if(flag){
        if(_this.notificationList.length){
          data.startLastUpdateTime = _this.notificationList[0].time;
        }
        data.page = 1;
      }

      this.$ajax.post('DynamicNotification/Paginate', data,{headers:{noLoading: true}}).then((res)=> {
        if(res.data.success){
          let result = res.data.data;
          /*正常的查询*/
          if((!flag || flag === 1) && data.page === 1){
            _this.totalPageCount = result.pageCount;
            searchParams.page = result.page;
            _this.notificationList = result.items;
            _this.$refs.scrollList.resetRender();
            _this.$refs.scrollList.scrollToTop();
          }else if((!flag || flag === 1) && data.page > 1){/*正常的滚动加载，将新的数据直接合并到之前的数据中*/
            _this.totalPageCount = result.pageCount;
            searchParams.page = result.page;
            _this.notificationList = _this.notificationList.concat(result.items);
          }
          if(flag && _this.show){
            console.log('刷新数据');
            /*将数据去重合并到数据的最前面*/
            let set1 = new Set(result.items);
            let set2 = new Set(_this.notificationList);
            _this.notificationList = _this.shareApi.dataDeduplication(Array.from(new Set([...set1,...set2])),'sourceRecordId');
            if(result.items.length > 1){
              _this.readAllNotification();
            }
            cycleQuery(window.g.dynamicNotificationDuration);
          }else if(flag && !_this.show){
            clearTimeout(_this.timeline);
            _this.getNewNotification();
          }
        }else if(flag){
          cycleQuery(window.g.dynamicNotificationDuration);
        }
      }).catch((err)=>{
        if(flag){
          cycleQuery(_this.$root.reconnectTime);
        }
      });
      function cycleQuery(time) {
        clearTimeout(_this.timeline);
        _this.timeline = setTimeout(function () {
          _this.getNotificationList(true);
        },time);
      }
    },
    handleToBottom: function(){
      if (searchParams.page < this.totalPageCount) {
        searchParams.page = searchParams.page + 1;
        this.getNotificationList();
      }
    },
    handleToTop:function(){
      if(_this.$root.isNotification && !(searchParams.userTypes && searchParams.userTypes.length > 0)
        || (searchParams.accessZoneIds && searchParams.accessZoneIds.length > 0)
        || (searchParams.areaIds && searchParams.areaIds.length > 0)){
        searchParams.page = 1;
        this.getNotificationList();
      }
    },
    //是否存在新的通知
    getNewNotification:function(){                                                                                                
      if( ! (_this.ApiService.accessToken && _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf('M_ViewDynamicNotification') > -1 ) ){
        return false; 
      }
      this.$ajax.get('DynamicNotification/CheckExistUnread',{headers: {noLoading: true}}).then(function (res) {
        if (res.data.success) {
          _this.$root.isNotification = res.data.data;
          _this.getNotification();
        } else if(res.data.message){
          _this.$root.isNotification = false;
        }
      })
    },
    /*定时刷新通知*/
    getNotification:function(){
      clearTimeout(_this.timeline);
      if( !(_this.ApiService.accessToken && _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf('M_ViewDynamicNotification') > -1 ) ){
        return false;
      }
      _this.timeline = setTimeout(() => {
        //判断是否已经打开记录弹层
        if(!_this.show){
          _this.getNewNotification();
        }
      },10000);
    },
    //将所有未读的消息全读
    readAllNotification:function(){
      this.$ajax.post('DynamicNotification/ReadAll',{},{headers:{noLoading: true}}).then((res)=> {
        if(res.data.success){
          _this.$root.isNotification = false;
        }
      });
    },
    // 获取是否需要展开
    getItemExpand:function(data){
      this.$nextTick(()=>{
        data.forEach((item, index)=>{
          let dom = _this.$refs['record'+item.id][0];
          if(dom && dom.clientWidth < dom.scrollWidth){
            item.needExpand = true;
            if(item.expand){
              item.expand = true
            }else{
              item.expand = false
            }
          }else{
            item.needExpand = false;
          }
        });
      });
    },
    // 获取下拉列表的数据
    getFilterData:function(){
      // 获取点位列表
      _this.shareApi.getAccessZoneOptions({enabledPaging:false, types:[1]}).done((result) => {
        _this.accessZoneList = result;
      });
      // 获取区域列表
      _this.shareApi.getAreaOptions({enabledPaging:false}).done((result) => {
        _this.areaList = result.items;
      });
    },
    // 跳转动态通知页
    goDynamicWindow:function(){
      let url = window.location.href.split("#")[0];
      window.open(url + '#/notificationWindow');
    },
    // 跳转记录
    goRecord:function(item){
      console.log('row is',item);
      let path,name;
      if(item.type === 0){
        path = "/registrationReport";
        name = 'User Registration';
        if(_this.$root.adminInfo.permissionCodes.indexOf('M_UserRegistration') <= -1){
          _this.messageNotice('error', "You don't have the permissions");
          return false
        }
      }else{
        if(_this.$root.adminInfo.permissionCodes.indexOf('M_GeneralAccess') <= -1){
          _this.messageNotice('error', "You don't have the permissions");
          return false
        }
        path = "/generalAccessReport";
        name = 'General Access';
      }
      _this.show = false; 
      if(_this.$route.path === path){
        //更新数据
        eventBus.$emit('uploadUserReport', item.sourceRecordId);
      }else{
        this.$router.push({name:name,params:{id:item.sourceRecordId,uniqueId:item.uniqueId}});
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/dynamicNotification.js